import React from "react";
import "./Footer.css";
import logo from "../Assets/logo1.png";
import { Link } from "react-router-dom";
import {
    FaFacebookF,
    FaInstagram,
    FaTiktok,
    FaWhatsapp,
    FaArrowUp,
} from "react-icons/fa";

const Footer = () => {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <footer className="footer">

            {/* LEFT SECTION */}
            <div className="footer-left">
                <img src={logo} alt="Dewalegama Jewellers Logo" className="footer-logo" />
                <h4 className="footer-brand">Dewalegama Jewellers</h4>
            </div>

            {/* CENTER - CONTACT SECTION */}
            <div className="footer-center">
                <h4 className="footer-title">Contact</h4>
                <p>
                    Address: 154/1, Kandy Road, Kadawatha. <br />
                    Tel: +94 71 088 1919 <br />
                    Email: dewalegama.jewellers@gmail.com <br />
                    Opening Hours: Mon - Sat 8:30 AM - 6:30 PM
                </p>
                <small>Closed on Sundays and Full Moon (Poya) days</small>
            </div>

            {/* INFORMATION SECTION */}
            <div className="footer-info">
                <h4 className="footer-title">Information</h4>
                <ul>
                    <li>
                        <Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link>
                    </li>
                    <li>
                        <Link to="/category" onClick={() => window.scrollTo(0, 0)}>Our Collection</Link>
                    </li>
                    <li>
                        <Link to="/about" onClick={() => window.scrollTo(0, 0)}>About Us</Link>
                    </li>
                    <li>
                        <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link>
                    </li>
                </ul>
            </div>

            {/* RIGHT SECTION */}
            <div className="footer-right">
                <h4>Get in Touch</h4>
                <p className="footer-subtext">You will find your next marketing value</p>

                <div className="footer-icons">
                    <a href="https://www.facebook.com/dewalegamajewellers" target="_blank" rel="noopener noreferrer">
                        <FaFacebookF className="icon" />
                    </a>
                    <a href="https://www.tiktok.com/search?q=dewalegama%20jewellers&t=1763748753848" target="_blank" rel="noopener noreferrer">
                        <FaTiktok className="icon" />
                    </a>
                    <a href="https://wa.me/94710881919?text=Hello!%20I%20would%20like%20to%20inquire%20about%20your%20jewellery%20collection." target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp className="icon" />
                    </a>
                    <a href="https://www.instagram.com/dewalegamajewellers/?hl=en" target="_blank" rel="noopener noreferrer">
                        <FaInstagram className="icon" />
                    </a>
                </div>

                <button className="scroll-button" onClick={scrollToTop}>
                    <FaArrowUp className="scroll-icon" />
                </button>
            </div>
        </footer>
    );
};

export default Footer;
